import React from "react";
import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import EnquiryForm from "../components/EnquiryForm";
import SectionHeader from "../components/SectionHeader";
import { business } from "../data/site";

export default function Kontakt() {
  return (
    <main id="main">
      <Seo path="/kontakt" title="Kontakt | Vinařství Brychta" description="Napište nám nebo zavolejte. Rádi vám připravíme nabídku degustace, ubytování nebo firemního programu." />
      <Breadcrumbs items={[{ label: "Kontakt" }]} />
      <section id="poptavka" className="max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionHeader as="h1" eyebrow="Napište nám" title="Řekněte nám, co plánujete"
            kicker="Napište termín, počet osob a představu. Ozveme se s konkrétní nabídkou a možnostmi." />
          <div className="mt-8 space-y-5">
            <ContactRow icon={<Phone size={18} />} label="Telefon"><a href={`tel:${business.phoneHref}`} data-testid="contact-phone" className="hover:text-burgundy">{business.phone}</a></ContactRow>
            <ContactRow icon={<Mail size={18} />} label="Vinařství, degustace, zážitky"><a href={`mailto:${business.emails.winery}`} data-testid="contact-email-winery" className="hover:text-burgundy">{business.emails.winery}</a></ContactRow>
            <ContactRow icon={<Mail size={18} />} label="Ubytování"><a href={`mailto:${business.emails.accommodation}`} data-testid="contact-email-accom" className="hover:text-burgundy">{business.emails.accommodation}</a></ContactRow>
            <ContactRow icon={<MapPin size={18} />} label="Adresa">{business.address.street}<br />{business.address.postal} {business.address.city}</ContactRow>
          </div>
          <a href={business.google.profileUrl} target="_blank" rel="noopener noreferrer" data-testid="maps-link" className="mt-6 inline-flex items-center gap-2 text-burgundy hover:text-burgundy-hover text-sm underline underline-offset-4">
            Otevřít Google Mapy <ArrowRight size={14} />
          </a>
        </div>
        <div className="lg:col-span-7 bg-cream p-6 md:p-10">
          <EnquiryForm />
        </div>
      </section>
    </main>
  );
}

function ContactRow({ icon, label, children }) {
  return (
    <div className="flex gap-4">
      <div className="text-burgundy mt-1">{icon}</div>
      <div>
        <div className="text-[11px] tracking-[.2em] uppercase text-charcoal/55">{label}</div>
        <div className="text-charcoal">{children}</div>
      </div>
    </div>
  );
}
